module.exports = __webpack_public_path__ + "img/ballast-icon.77e9c24e.jpg";